export const collegeContacts = {
  website: "https://mace.ac.in/",
  alumniWebsite: "https://mace.ac.in/alumni/",
  alumniCommunity: "https://macealumni.com/",
  address: "Mar Athanasius College of Engineering, Kothamangalam, Kerala 686 666",
  phones: ["+91 94477 03636", "+91 485 2822363", "+91 485 2823383"],
  email: "office@mace.ac.in",
  verified: "September 28, 2026",
};

export const alumniOfficers = [
  {
    role: "President",
    name: "Dr. Bos Mathew Jos",
    detail: "Principal",
    phone: "+91 94468 06007",
    email: "principal@mace.ac.in",
    image: "/media/college/bos-mathew-jos.webp",
  },
  {
    role: "Secretary",
    name: "Dr. Kora T Sunny",
    phone: "+91 98954 23893",
    email: "alumni@mace.ac.in",
    image: "/media/college/kora-sunny.webp",
  },
  {
    role: "Treasurer",
    name: "Prof. Neethu Salim",
    phone: "+91 90488 36836",
    email: "alumni@mace.ac.in",
    image: "/media/college/neethu-salim.webp",
  },
];

export const campusPhotos = [
  { src: "/media/college/campus-01.webp", alt: "Students and visitors on the MACE campus" },
  { src: "/media/college/campus-02.webp", alt: "Mar Athanasius College of Engineering campus view" },
  { src: "/media/college/campus-03.webp", alt: "Academic building at the MACE campus" },
  { src: "/media/college/campus-04.webp", alt: "Campus life at Mar Athanasius College of Engineering" },
  { src: "/media/college/campus-05.webp", alt: "Green spaces on the MACE campus" },
  { src: "/media/college/campus-06.webp", alt: "Another view of the MACE campus in Kothamangalam" },
];

export const connectionIdeas = [
  {
    number: "01",
    title: "City circles",
    description: "Lightweight local chapters for coffee, family lunches, walks, and airport meetups—without waiting five years for a grand reunion.",
    action: "Start a local reunion",
  },
  {
    number: "02",
    title: "The mentor bench",
    description: "A searchable list of classmates willing to offer a thirty-minute career conversation, an introduction, or guidance to a MACE student.",
    action: "Volunteer your time",
  },
  {
    number: "03",
    title: "Memory prompts",
    description: "Monthly questions—your first lab partner, the canteen order, the professor you still quote—collected as short notes or voice clips.",
    action: "Add a memory",
  },
  {
    number: "04",
    title: "Find our classmates",
    description: "A respectful opt-in roster for reconnecting with people whose contact information has gone quiet, coordinated by branch representatives.",
    action: "Help reconnect",
  },
  {
    number: "05",
    title: "Skills exchange",
    description: "Ask the class for a specialist, a local recommendation, a speaker, or a second opinion—and offer the same in return.",
    action: "Post an ask",
  },
  {
    number: "06",
    title: "The next 30",
    description: "Capture the projects, causes, and scholarships the class wants to build together before the next milestone reunion.",
    action: "Propose an idea",
  },
];

export const branches = [
  "Civil A",
  "Civil B",
  "Computer",
  "Electrical A",
  "Electrical B",
  "Electronics",
  "Mechanical A",
  "Mechanical B",
];
